import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PreventBackNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Save location.state to sessionStorage
    if (location.state) {
      try {
        sessionStorage.setItem("savedState", JSON.stringify(location.state));
      } catch (e) {
        if (e.name === "QuotaExceededError") {
          console.error("Storage limit exceeded. Consider reducing state size.");
        }
      }
    }

    const preventBack = (event) => {
      event.preventDefault();
      window.history.forward(); // Prevents the user from going back
    };

    const savedState = sessionStorage.getItem("savedState");
    const state = savedState ? JSON.parse(savedState) : null;

    // Push state into history to persist across refresh
    window.history.pushState({ state }, "", window.location.href);
    window.history.forward();

    window.addEventListener("popstate", preventBack);

    return () => {
      window.removeEventListener("popstate", preventBack);
    };
  }, [location.pathname, location.state]);

  // Restore location.state after refresh
  useEffect(() => {
    if (!location.state) {
      const savedState = sessionStorage.getItem("savedState");
      if (savedState) {
        const parsedState = JSON.parse(savedState);
        navigate(location.pathname, { state: parsedState, replace: true });

        // Update history.pushState with restored state
        window.history.replaceState({ state: parsedState }, "", window.location.href);
      }
    }
  }, [location, navigate]);

  return null;
};

export default PreventBackNavigation;
